import clearSession from '@utils/browserDataManipulators/clearSession';
import clearLocalStorage from '@utils/browserDataManipulators/clearLocalStorage';

export { clearLocalStorage, clearSession };
